import * as React from 'react';
import { SVGProps } from 'react';

const FileIconZipSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 34 40" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M32 0H2a2 2 0 0 0-2 2v36a2 2 0 0 0 2 2h30a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Z" />
    <path
      opacity={0.6}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 17H9v16h16V17h-7v1h6v14H10V17Zm2 0h3v1h2v1h-2v1h2v1h-2v1h2v1h-2v1h2v1h-2v1h1v4h-3v-4h1v-2h-2v-1h2v-1h-2v-1h2v-1h-2v-1h2v-1h-2v-1Zm3 10h-1v2h1v-2Z"
      fill="#fff"
    />
    <path
      d="M18 5v1h-1V5h1ZM15 8V7h3v4h1v1h-4v-1h2V8h-2ZM14 12h-4v-1l2.5-3H10V7h4v1l-2.32 3H14v1Z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.8 7v.24c.207-.16.473-.24.8-.24h.7c.587 0 1.017.127 1.29.38.273.247.41.653.41 1.22v1.8c0 .56-.14.967-.42 1.22-.273.253-.7.38-1.28.38h-1.29v2H20V7h.8Zm.85 1c-.22 0-.383.06-.49.18a.53.53 0 0 0-.16.37l.01 2.45h1.24c.247 0 .433-.057.56-.17.127-.113.19-.273.19-.48v-1.7c0-.207-.063-.367-.19-.48-.127-.113-.313-.17-.56-.17h-.6Z"
      fill="#fff"
    />
  </svg>
);
export default FileIconZipSizeM;
